import config from '../data/config.json';
import dict from '../data/dictionary.json';
import { alertQuestionnaireTemplate } from '../data/htmlTemplates.js';

import L from 'leaflet';
import bootstrap from "bootstrap/dist/js/bootstrap.bundle.min.js";

import { Sesion, Datos, Layers, obtenerURL } from '../main.js';
import { getLiteral} from './util.js';
import { getGrid, getGridBounds } from './grid.js';
import { discoverPlotsInCell } from './dataManager.js';
import { pintarRegiones, ponerChartPopupRegion } from './regions.js';
import { pintarParcelas, quitarParcelas, popupParcela, ponerChartPopupParcela, ponerChartPopupPoli } from './plots.js';
import { initMapEvent, sendTimedEvent, sendMapTimeoutEvent, setEventData } from './events.js';

// variables globales
let Mimapa, Mitilelayer;
let tostadaIFN2pend = true;

//////////////////////
// INICIALIZACIÓN MAPA
function inicializarMapa() {
	// CARGO MAPA CON LA LOCALIZACIÓN DE LA CONFIGURACIÓN

	// alternativas de mapas
	// https://leaflet-extras.github.io/leaflet-providers/preview/

	// meto tap: false, que parece es una fuente de problemas
	// nov-23: pongo preferCanvas: true que mejora mucho el borrado (y el resto parece que sigue bien), también pongo doubleClickZoom: false
	// dec-23: incluyo scrollWheelZoom: 'center' para reducir saltos raros con el zoom en el ratón de Apple
	Mimapa = L.map('mimapa', {maxBounds: config.geoMaxBounds, geoMaxBoundsViscosity: config.geoMaxBoundsViscosity, zoomControl: false, tap: false, 
		doubleClickZoom: false, scrollWheelZoom: 'center', wheelDebounceTime: 100, preferCanvas: true} )
		.setView([Sesion.estado.loc.lat, Sesion.estado.loc.lng], Sesion.estado.loc.z);
	// cargo el tile layer que corresponda tras cargar la URL
	const gc = obtenerConfigMapaBase();
	Mitilelayer = gc.wms? L.tileLayer.wms(gc.url, gc.options).addTo(Mimapa) : L.tileLayer(gc.url, gc.options).addTo(Mimapa);
	
	
	// REPOSICIONO CONTROLES DE ZOOM Y MUESTRO ESCALA DEL MAPA
	L.control.scale( {imperial: false, position: 'bottomright'} ).addTo(Mimapa); // sin la escala imperial
	if (!L.Browser.mobile) { // sólo botones de zoom para dispositivos no móviles
		L.control.zoom( { position: 'bottomright',
			zoomInTitle: getLiteral(dict.zoomin),
			zoomOutTitle: getLiteral(dict.zoomout),
		} ).addTo(Mimapa);
	}
	// handler cada vez que se abra un popup (para pintar el chart)
	Mimapa.on("popupopen", function(e) {
		// guardo el popup cada vez que se abre uno
		Sesion.popup = e.popup;
		// cojo el DOM element del popup
		const popel = Sesion.popup.getElement();	
		// extraigo la iri y el canvas (si existe)
		const iri = popel.querySelector(".popup").getAttribute("iri");
		const canvas = popel.querySelector("canvas");
		// caso particular para los popups pendientes de regenerar de las parcelas
		if (Sesion.parPopupsRegenerar[iri]) {
			// elimino de los pendientes
			delete Sesion.parPopupsRegenerar[iri]; 
			// cierro este popup
			const latlng = Sesion.popup.getLatLng();
			Mimapa.closePopup();
			// regenero el popup y lo abro
			const op = popupParcela(Datos.parcelas[iri]); // obtengo el popup
			if (Array.isArray(Sesion.parPintadas[iri])) {
				for (let sc of Sesion.parPintadas[iri])
					sc.bindPopup(op.popup, op.opcs);
				Sesion.parPintadas[iri][0].openPopup(latlng);
			}
			else {
				Sesion.parPintadas[iri].bindPopup(op.popup, op.opcs);
				Sesion.parPintadas[iri].openPopup(latlng);
			}		
			return;
		}
		// si existe el canvas y está escondido, entonces hay que preparar el chart
		if (canvas && canvas.classList.contains("d-none")) {
			if (popel.querySelector(".parcela"))
				ponerChartPopupParcela(canvas, iri);
			else if (popel.querySelector(".reg"))
				ponerChartPopupRegion(canvas, iri);
			else if (popel.querySelector(".poli")) {
				 const ind = Number(iri.substring(4, iri.length)); // será poliXXXX
				ponerChartPopupPoli(canvas, ind);
			}
		}
	});
}


////////////
// MAPA BASE
function obtenerConfigMapaBase() {
	if (Sesion.estado.mapType === config.mapConfig.mapType[1]) // "satellite"
		return config.geoConfigs.esri;
	else	// "default"
		return config.geoConfigs.voyager;
}

function actualizarMapaBase(gcold) {
	// borro atribuciones del mapa
	for (let clave of Object.keys(Mimapa.attributionControl._attributions))
		Mimapa.attributionControl.removeAttribution(clave);
	// compruebo si hay que cambiar sólo la URL o si hay que regenerar Mitilelayer
	const gcnew = obtenerConfigMapaBase();
	if (!gcold || gcold.wms == gcnew.wms) {
		// cambio la URL
		Mitilelayer.setUrl(gcnew.url);
		// pongo la nueva atribución
		Mimapa.attributionControl.addAttribution(gcnew.options.attribution);
	}
	else {
		// elimino tileLayer anterior
		Mimapa.removeLayer(Mitilelayer);
		// pongo tileLayer nueva
		Mitilelayer = gcnew.wms? L.tileLayer.wms(gcnew.url, gcnew.options).addTo(Mimapa) 
			: L.tileLayer(gcnew.url, gcnew.options).addTo(Mimapa);
	}
}



////////////////////////////
// BUCLE DE CONTROL DEL MAPA
function mapaMovido() {
	if (!Sesion.errordataprov) {
		if (Sesion.actualizandoMapa) {
			Sesion.mapaMovido = true; // pendiente de actualizar el mapa...
			console.log("Mapa movido: actualización de mapa pendiente...");
		}
		else // llamo a actualizar el mapa
			actualizarMapa();
	}
}
async function actualizarMapa() {
	// actualizo zoom
	const zoomPrevio = Sesion.zoom;
	Sesion.zoom = Mimapa.getZoom();
		
	// obtengo grid de celdas para el mapa
	Sesion.zoomUsados[Sesion.zoom] = true; // para el cacheo
	const grid = getGrid(Mimapa.getBounds(), Sesion.zoom);
	
	// inicializaciones progreso y estadísticos
	Sesion.infoParcelas = {
		celdas: (1 + grid.cellE - grid.cellW) * (1 + grid.cellN - grid.cellS),
		celdasCompletadas: [],
		parcelasCompletadas: [],
		urlsRed: [],
		urlsCache: [],
		ifn: Sesion.estado.ifn,
		pintar: true
	};
	Sesion.progreso = pintarProgreso;
	//console.warn("Total celdas: " + Sesion.infoParcelas.celdas);

	
	// inicialización primordial
	inicioActualizarMapa();
	const idtimeout = Sesion.idTimeoutActualizar;
			
	// actualizo info celdas para GA
	setEventData('num_cells', Sesion.infoParcelas.celdas);
	
	/* TODO: pinto
	for (let x=grid.cellW; x<=grid.cellE; x++) {
		for (let y=grid.cellS; y<=grid.cellN; y++) {
			const cb = getCeldaBounds(x, y, Sesion.zoom);
			L.rectangle(cb, {color: "#ff7800", weight: 1}).addTo(Mimapa);
		}
	}*/	
	

	
	//
	// REGIONES
	//	
	pintarRegiones(Sesion.estado.mapDetails === config.mapConfig.mapDetails[1]);
			
	
	//
	// PARCELAS 
	//
	
	// ajuste radio parcela
	// calculo radio para pintar según el zoom
	const radio = Sesion.zoom > config.zCambioRadio? config.radioParcela - (config.radioParcela - config.radioParcelaN3)*(Sesion.zoom - config.zCambioRadio)/(config.zArbol - config.zCambioRadio)
				 : config.radioParcela;
	// si no coincide el radio con el de la sesión, me cargo la capa
	if (radio != Sesion.radioParPintadas)
		await quitarParcelas();
	// guardo radio sesión
	Sesion.radioParPintadas = radio;
	//console.info("Zoom: " + Sesion.zoom + " - Radio: " + radio);
		
	// limpieza de parcelas según el modo
	const gridBounds = getGridBounds(grid, Sesion.zoom);
	let purisBorrar = [];	
	console.time("Borrado de parcelas");		
	// detección de parcelas a borrar
	for (let puri in Sesion.parPintadas) {
		if (Datos.parcelas[puri].ifn !== Sesion.infoParcelas.ifn) // fuera si distinta versión
			purisBorrar.push(puri);
		else {	// miro coordenadas
			const pbounds = Array.isArray(Sesion.parPintadas[puri])? Sesion.parPintadas[puri][0].getBounds() : Sesion.parPintadas[puri].getBounds();
			if (!gridBounds.intersects(pbounds) && !gridBounds.contains(pbounds) )
				purisBorrar.push(puri);
		}
	}
	console.info("#parcelas pintadas: " + Object.keys(Sesion.parPintadas).length + " - #parcelas a borrar: " + purisBorrar.length);
	// vamos con el borrado	parcela a parcela	
	for (let purib of purisBorrar) {
		if (Array.isArray(Sesion.parPintadas[purib])) {
			for (let parelb of Sesion.parPintadas[purib])
				Layers.parcs.removeLayer(parelb);
		}
		else
			Layers.parcs.removeLayer(Sesion.parPintadas[purib]);
		delete Sesion.parPintadas[purib];
	}
	console.timeEnd("Borrado de parcelas");
	
	
	// inicializo array de promesas celdas para luego coordinar
	const dpcpromises = [];
	//let objceldas = [];
	// trabajo celda a celda
	for (let x=grid.cellW; x<=grid.cellE; x++) {
		for (let y=grid.cellS; y<=grid.cellN; y++) {
			// preparo objeto de la celda
			const objcelda = {
				zoom: Sesion.zoom,
				cellX: x,
				cellY: y,
				et: 'z' + Sesion.zoom + '_x' + x + '_y' + y + '_' + Sesion.infoParcelas.ifn,
				ifn: Sesion.infoParcelas.ifn,
				idtimeout: idtimeout // para actualizar Sesion.infoTeselas sólo si toca
			};
			// guardo objcelda
			//objceldas.push(objcelda);
			// hago la petición para descubrir las parcelas de la celda
			dpcpromises.push( discoverPlotsInCell(objcelda, Sesion) );
		}
	}
	
	// espero a que terminen todas las promesas de las celdas para hacer logging
	await Promise.all(dpcpromises);
	
	// logging si no ha vencido el temporizador de actualización...
	if (idtimeout == Sesion.idTimeoutActualizar) {
		// logging celdas parcelas
		const urlsRed = Sesion.infoParcelas.urlsRed.reduce((memo, num) => memo + num, 0);
		const urlsCache = Sesion.infoParcelas.urlsCache.reduce((memo, num) => memo + num, 0);
		//const clistas = Sesion.infoParcelas.celdasCompletadas.reduce((memo, num) => memo + num, 0);
		const plistas = Sesion.infoParcelas.parcelasCompletadas.reduce((memo, num) => memo + num, 0);
		const ppintadas = Object.keys(Sesion.parPintadas).length;
		console.info("parcelas I" + Sesion.idTimeoutActualizar  + " #celdas: " + Sesion.infoParcelas.celdas + 
			//" #celdas listas: " + clistas + " #parcelas: " + plistas + " #parcelas pintadas: " + ppintadas + 
			" #parcelas: " + plistas + " #parcelas pintadas: " + ppintadas + 
			" #urlsRed: " + urlsRed + " #urlsCache: " + urlsCache);
		// actualizo info urls para GA
		setEventData('urls_network', urlsRed);
		setEventData('urls_cache', urlsCache);		
	}
		
	// rutina fin actualización del mapa si no ha vencido el temporizador de actualización
	if (idtimeout == Sesion.idTimeoutActualizar) {
		finActualizarMapa();
			
		// muestro tostada IFN2 (primera vez en la sesión)
		if (tostadaIFN2pend && Sesion.estado.ifn === "ifn2") {		
			// aviso con una tostada de agujeros en el IFN2
			document.getElementById("mitostadaStrong").innerHTML = getLiteral(dict.title);
			document.getElementById("mitostadaBody").innerHTML = getLiteral(dict.toastIFN2);
			const tostada = bootstrap.Toast.getOrCreateInstance(document.getElementById('mitostada'));
			tostada.show();
			// ya no muestro más		
			tostadaIFN2pend = false;
		}	
	}	
}
function inicioActualizarMapa() {
	// mapa actual
	Sesion.mapaMovido = false;
	// quito timeout anterior (importante llamar tras Sesion.mapaMovido = false)
	finActualizarMapa();
	// pongo bloqueo a actualizaciones
	Sesion.actualizandoMapa = true;
	
	// pinto la barra de progreso
	pintarProgreso(true, Sesion);
	
	// actualizo la localización del estado de la sesión
	Sesion.estado.loc.lat = Mimapa.getCenter().lat;
	Sesion.estado.loc.lng = Mimapa.getCenter().lng;
	Sesion.estado.loc.z = Mimapa.getZoom();
		
	// reajusto url y actualizo página en la historia si hay cambio en URL
	const newurl = obtenerURL();
	if (window.location !== newurl)
		history.replaceState(Sesion.estado, "", newurl);
	
	// ajuste propiedad meta de la url
	document.querySelector("meta[property='og:url']").setAttribute('content', window.location.href);
	
	// pongo timeout para que quite el bloqueo tras 10 segundos (por si acaso se bloquea indefinidamente)
	Sesion.idTimeoutActualizar = setTimeout(function(){	
		// mando evento de timeout a GA	
		sendMapTimeoutEvent();
		
		console.warn("Venció el temporizador de " +  Math.round(Sesion.timeout/1000) + " segundos antes de terminar de actualizar el mapa");		
		console.groupEnd();
		
		Sesion.actualizandoMapa = false;
		Sesion.idTimeoutActualizar = null;
		// actualizo timeout
		Sesion.timeout += config.timeoutStep;
		Sesion.huboTimeout = true;		
		// y llamo a mapaMovido
		mapaMovido();
	}, Sesion.timeout);
	// logging
	console.group("I" + Sesion.idTimeoutActualizar + " - Actualizando mapa");
	console.time("Actualización I" + Sesion.idTimeoutActualizar);
	console.log("URL: " + window.location);
	console.log("Temporizador actualización: " +  Math.round(Sesion.timeout/1000) + " segundos")
	//console.log(" -> bloqueando actualizaciones y poniendo temporizador antibloqueo: " + Sesion.idTimeoutActualizar);
	
	// inicializo el evento para enviar a Google Analytics
	initMapEvent();
}
function finActualizarMapa() {
	//console.log(" -> fin de actualización del mapa, quito temporizador antibloqueo");
	Sesion.actualizandoMapa = false; // quito bloqueo
	// cancelo timeout anterior (si existiera)
	if (Sesion.idTimeoutActualizar != null) {
		clearTimeout(Sesion.idTimeoutActualizar);
		console.timeEnd("Actualización I" + Sesion.idTimeoutActualizar);
		console.info("I" + Sesion.idTimeoutActualizar + " - Fin actualización del mapa");
		console.groupEnd();
		Sesion.idTimeoutActualizar = null;
		// escondo la barra de progreso
		pintarProgreso(false, Sesion);
		// actualización timeout
		if (!Sesion.huboTimeout && Sesion.timeout > config.timeout) // si no hubo timeout resto config.timeoutStep (sin superar el valor inicial)
			Sesion.timeout -= config.timeoutStep;
		Sesion.huboTimeout = false; // inicializo para la siguiente
		// mando evento de fin de actualización del mapa
		sendTimedEvent();	
	}
		
	// llamo a actualizar el mapa si es necesario
	if (Sesion.mapaMovido) {
		console.info("El mapa se había movido, vuelvo a actualizar");
		mapaMovido();
	}
	else if (Sesion.ponerAlertaCuestionario) {
		// miro si pongo el cuestionario
		const ahora = Date.now();
		if (ahora - Sesion.inicioSesion > config.intraSessionQGap) {
			// pongo el cuestionario
			document.getElementById("mimapa").insertAdjacentHTML("beforeend", alertQuestionnaireTemplate);
			// ya no lo vuelvo a poner en la sesión
			Sesion.ponerAlertaCuestionario = false;
			// y pongo los handlers de los botones
			document.getElementById("questbotyes").addEventListener("click", function() {
				// vamos al questionario (nueva pestaña)
				const questurl = this.getAttribute("questurl");
				const win = window.open(questurl, '_blank');
				win.focus();
				// no más cuestionarios
				localStorage.setItem('cuestionarioNo', true);
				// quito la alerta
				document.getElementById("questalert").remove();
			});
			document.getElementById("questbotno").addEventListener("click", function() {
				// reajusto a ahora más 3 semanas
				const nuevo = ahora + 21*24*3600*1000;
				localStorage.setItem('timestampPrimeraSesion', nuevo);
				// quito la alerta
				document.getElementById("questalert").remove();
			});
			document.getElementById("questbotlater").addEventListener("click", function() {
				// reajusto a ahora 
				localStorage.setItem('timestampPrimeraSesion', ahora);
				// quito la alerta
				document.getElementById("questalert").remove();
			});
		}
	}
}

function pintarProgreso(mostrar, sesion) {
	const libarra = document.getElementById('li-barra');
	if (mostrar) {
		// pongo el overlay
		document.getElementById('mapoverlay').classList.remove('d-none');
		// calculo celdas listas
		const clistas = sesion.infoParcelas.celdasCompletadas.reduce((memo, num) => memo + num, 0);
		const porc = Math.floor( 100 * clistas / sesion.infoParcelas.celdas );
		// pongo mensajillo
		document.getElementById('mapclue').innerHTML = '<i>' + getLiteral(dict.downloadingPlots) + '</i>';		
		// cojo refs barra
		const mibarradiv = document.getElementById('mibarradiv');
		const mibarra = document.getElementById('mibarra');
		// ajusto barra
		mibarradiv.setAttribute('aria-valuenow', porc);
		mibarra.style.width = porc + '%';
		mibarra.innerHTML = porc + '%';
		// muestro la barra de progreso
		libarra.classList.remove('d-none');	
	}
	else {
		// quito el overlay
		document.getElementById('mapoverlay').classList.add('d-none');		
		// escondo la barra
		libarra.classList.add('d-none');		
	}
}

export { Mimapa, inicializarMapa, mapaMovido, finActualizarMapa, obtenerConfigMapaBase, actualizarMapaBase };